import React from "react";
import { RewardDetailContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { userService } from "apiServices";
import { withTranslation } from "react-i18next";
import { Buttons, Displays } from "components";
import moment from "moment";
import { IMG_PATH } from "utils/constants/imgPath";

class RewardDetailContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { router } = this.props;
    let res = await userService.GET_MY_REWARD_E_VOUCHER_DETAIL(
      router.params?.id,
    );
    if (res && res.status === 200) {
      this.setState({
        data: res.data,
        isLoading: false,
      });
    }
  };

  handleClickBack = () => {
    this.props.router.navigate(-1);
  };

  render() {
    const { t } = this.props;
    const { isLoading, data } = this.state;
    return (
      <RewardDetailContainerStyled>
        {isLoading ? (
          <Displays.Loading />
        ) : (
          <div className="reward_container_layout">
            <div className="info_list_block">
              <div className="info_item mb_22">
                {/* <img
                  className="reward_img"
                  src={
                    data.reward_detail?.img
                      ? IMG_PATH + data.reward_detail?.img
                      : "/assets/images/icons/mock-my-reward.png"
                  }
                  alt="reward"
                /> */}
                <div className="reward_img_smooth">
                  <Displays.ImageSmooth
                    src={
                      data.reward_detail?.img
                        ? IMG_PATH + data.reward_detail?.img
                        : "/assets/images/mockups/activity-news.jpg"
                    }
                    alt="reward"
                    aspectRatio="1 / 1"
                  />
                </div>
              </div>
              <div className="info_item">
                <div className="info_label">Reward Name</div>
                <div className="info_value">{data.reward_detail?.name}</div>
              </div>
              <div className="info_item">
                <div className="info_label">{t("Details", { ns: "common" })}</div>
                <div className="info_value">
                  {data.reward_detail?.description}
                </div>
              </div>
              <div className="info_item">
                <div className="info_label">{t("Available uses", { ns: "common" })}</div>
                <div className="info_value">{data.time_to_use}</div>
              </div>
              <div className="info_item">
                <div className="info_label">{t("Used count", { ns: "common" })}</div>
                <div className="info_value">{data.used}</div>
              </div>
              <div className="info_item">
                <div className="info_label">{t("Redeemed date", { ns: "common" })}</div>
                <div className="info_value">
                  {moment(data.redeemed_at).format("DD/MM/YYYY")}
                </div>
              </div>
              <div className="info_item">
                <div className="info_label">{t("Expiry date", { ns: "common" })}</div>
                <div className="info_value">
                  {moment(data.reward_detail?.expired_at).format("DD/MM/YYYY")}
                </div>
              </div>
              <div className="info_item">
                <div className="info_label">E-Voucher</div>
                <div className="info_value">
                  <span>{data.code}</span>
                </div>
              </div>
            </div>
            <div className="btn_back">
              <Buttons.BgStandard
                theme_white_purple
                label={t("Back", { ns: "common" })}
                onClick={this.handleClickBack}
              />
            </div>
          </div>
        )}
      </RewardDetailContainerStyled>
    );
  }
}

export default withRouter(withTranslation(["common"])(RewardDetailContainer));
